// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snackbars_container__E2t2c {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: auto !important;
  bottom: 0 !important;
  pointer-events: none;
}
.snackbars_container__E2t2c > * {
  pointer-events: auto;
}

.snackbars_toast__W9Ej- {
  --toastify-toast-min-height: auto !important;
  --toastify-toast-max-height: auto !important;
  --toastify-toast-width: calc(min(800px, 90vw)) !important;
  display: inline-block !important;
  background: #272A36 !important;
  border-radius: 8px !important;
  float: right;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.snackbars_body__n7QhI {
  margin: 0 !important;
  padding: 0 !important;
}
.snackbars_body__n7QhI > * {
  line-height: 0;
}

@media (max-width: 800px) {
  .snackbars_actions__GLSl1 {
    justify-content: flex-end;
    margin-left: 0 !important;
  }
  .snackbars_toast__W9Ej- {
    max-width: 90vw;
    margin-bottom: 8px;
  }
}
.snackbars_content__YSBXe {
  font-family: "Roboto", arial, sans-serif;
  min-width: 1px;
}

.snackbars_wrapper__zMDkA {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
}

.snackbars_icon__2346U {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.snackbars_title__y0AgM {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 1px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;
  margin-top: 0;
  margin-bottom: 0;
}

.snackbars_message__\\+IS4r {
  margin-top: 2px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #FFFFFF;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.snackbars_actions__GLSl1 {
  flex-shrink: 0;
  margin-left: 24px;
  display: flex;
}
.snackbars_actions__button__FgYqM {
  padding: 8px 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #FFFFFF;
  background: transparent;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.snackbars_animate__animated__jMPgm {
  animation-duration: 0.3s;
  animation-fill-mode: both;
}
@keyframes snackbars_fadeIn__2RBc4 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.snackbars_animate__fadeIn__ZZXwC {
  animation-name: snackbars_fadeIn__2RBc4;
}

.snackbars_animate__fadeOut__qQhKF {
  animation-name: snackbars_fadeIn__2RBc4;
  animation-direction: reverse;
}`, "",{"version":3,"sources":["webpack://./../../packages/sdk/src/components/snackbars/snackbars.module.scss"],"names":[],"mappings":"AA+CA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;AA9CF;AAgDE;EACE,oBAAA;AA9CJ;;AAkDA;EACE,4CAAA;EACA,4CAAA;EACA,yDAAA;EACA,gCAAA;EAEA,8BAAA;EAEA,6BAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;AAjDF;;AAoDA;EACE,oBAAA;EACA,qBAAA;AAjDF;AAmDE;EACE,cAAA;AAjDJ;;AAqDA;EAKE;IAEE,yBAAA;IACA,yBAAA;EAvDF;EA0DA;IACE,eAAA;IACA,kBAAA;EAxDF;AACF;AA2DA;EACE,wCAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,8BAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAzDF;;AA4DA;EAME,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AA/DF;;AAkEA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAhEF;;AAmEA;EACE,cAAA;EACA,iBAAA;EACA,aAAA;AAhEF;AAkEE;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAhEJ;;AAqEA;EACE,wBAAA;EACA,yBAAA;AAlEF;AA8EA;EACE;IACE,UAAA;EAnEF;EAsEA;IACE,UAAA;EApEF;AACF;AAsEA;EAEE,uCAAA;AApEF;;AAuEA;EAEE,uCAAA;EACA,4BAAA;AApEF","sourcesContent":["//.warning {\n//  background: #FEF9EB !important;\n//  border: 1px solid #F9E8B5 !important;\n//  color: #272A36 !important;\n//  box-shadow: none !important;\n//\n//  border-radius: 8px !important;\n//  min-width: auto !important;\n//  padding: 6px 16px 6px 18px !important;\n//\n//  svg {\n//    margin-right: 12px;\n//  }\n//}\n//\n//.success {\n//  background: #EEFBF7 !important;\n//  border: 1px solid #B4DCCF !important;\n//  color: #272A36 !important;\n//  box-shadow: none !important;\n//\n//  border-radius: 8px !important;\n//  min-width: auto !important;\n//  padding: 6px 16px 6px 18px !important;\n//\n//  svg {\n//    margin-right: 12px;\n//  }\n//}\n//\n//.error {\n//  background: #FBEEEE !important;\n//  border: 1px solid #F2CACA !important;\n//  color: #272A36 !important;\n//  box-shadow: none !important;\n//\n//  border-radius: 8px !important;\n//  min-width: auto !important;\n//  padding: 6px 16px 6px 18px !important;\n//\n//  svg {\n//    margin-right: 12px;\n//  }\n//}\n//\n//\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: auto !important;\n  bottom: 0 !important;\n  pointer-events: none;\n\n  &>* {\n    pointer-events: auto;\n  }\n}\n\n.toast {\n  --toastify-toast-min-height: auto !important;\n  --toastify-toast-max-height: auto !important;\n  --toastify-toast-width: calc(min(800px, 90vw)) !important;\n  display: inline-block !important;\n\n  background: #272A36 !important;\n\n  border-radius: 8px !important;\n  float: right;\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n\n.body {\n  margin: 0 !important;\n  padding: 0 !important;\n\n  &>* {\n    line-height: 0;\n  }\n}\n\n@media(max-width: 800px) {\n  .wrapper {\n    //flex-wrap: wrap;\n  }\n\n  .actions {\n    //width: 100%;\n    justify-content: flex-end;\n    margin-left: 0 !important;\n  }\n\n  .toast {\n    max-width: 90vw;\n    margin-bottom: 8px;\n  }\n}\n\n.content {\n  font-family: 'Roboto', arial, sans-serif;\n  min-width: 1px;\n}\n\n.wrapper {\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n}\n\n.title {\n  //display: -webkit-box;\n  //-webkit-line-clamp: 1;\n  //-webkit-box-orient: vertical;\n  //overflow: hidden;\n\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 1px;\n\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: #FFFFFF;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.message {\n  margin-top: 2px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #FFFFFF;\n\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.actions {\n  flex-shrink: 0;\n  margin-left: 24px;\n  display: flex;\n\n  &__button {\n    padding: 8px 16px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: #FFFFFF;\n    background: transparent;\n    border: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n}\n\n\n.animate__animated {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n.animate__fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n}\n\n.animate__fadeOut {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n  animation-direction: reverse;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `snackbars_container__E2t2c`,
	"toast": `snackbars_toast__W9Ej-`,
	"body": `snackbars_body__n7QhI`,
	"actions": `snackbars_actions__GLSl1`,
	"content": `snackbars_content__YSBXe`,
	"wrapper": `snackbars_wrapper__zMDkA`,
	"icon": `snackbars_icon__2346U`,
	"title": `snackbars_title__y0AgM`,
	"message": `snackbars_message__+IS4r`,
	"actions__button": `snackbars_actions__button__FgYqM`,
	"animate__animated": `snackbars_animate__animated__jMPgm`,
	"animate__fadeIn": `snackbars_animate__fadeIn__ZZXwC`,
	"fadeIn": `snackbars_fadeIn__2RBc4`,
	"animate__fadeOut": `snackbars_animate__fadeOut__qQhKF`
};
export default ___CSS_LOADER_EXPORT___;
